import React from 'react';
import moment from 'moment';
import { Oval } from 'react-loader-spinner';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

import { useAppSelector } from '../../../../app/hooks';
import { PunchCardsTable } from '../PunchCardsTable/PunchCardsTable';
import { PunchCardsForAllDrivers, PayPeriodResponse } from '../../../../models';

import './PunchCardsCard.scss';

export interface PunchCardsCardProps {
  currentPayPeriod?: PayPeriodResponse;
  onPreviousPayPeriod: () => void;
  onNextPayPeriod: () => void;
  viewDriverDetails: React.Dispatch<React.SetStateAction<PunchCardsForAllDrivers | undefined>>;
}

export function PunchCardsCard(props: PunchCardsCardProps) {
  const { currentPayPeriod, onPreviousPayPeriod, onNextPayPeriod, viewDriverDetails } = props;

  const getPunchCardSummariesAPI = useAppSelector(state => state.punchCards.getPunchCardSummariesAPI);
  const refreshPunchCardSummariesAPI = useAppSelector(state => state.punchCards.refreshPunchCardSummariesAPI);
  const getPayPeriodAPI = useAppSelector(state => state.punchCards.getPayPeriodAPI);

  const isLoading = getPunchCardSummariesAPI.loading || refreshPunchCardSummariesAPI.loading || getPayPeriodAPI.loading;

  const formatPayPeriodDates = () => {
    if (!currentPayPeriod) return '';
    const start = moment(currentPayPeriod.payPeriod.startDate);
    const end = moment(currentPayPeriod.payPeriod.endDate);
    return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
  };

  return (
    <div className='punch-cards-card-component'>
      <div className='title-container'>
        <div className='left-container'>
          <div className='title'>Punch Cards</div>
        </div>

        <div className='right-container'>
          <div className='pay-period-picker'>
            <div className='loading-indicator'>
              {isLoading && <Oval color="#0A60BB" height={20} width={20} secondaryColor="#B3B3B3"/>}
            </div>
            <div
              className={`nav-button ${!currentPayPeriod?.payPeriod.previousId ? 'disabled' : ''}`}
              onClick={onPreviousPayPeriod}
            >
              <BsChevronLeft />
            </div>
            <div className='pay-period-dates'>
              {formatPayPeriodDates()}
            </div>
            <div
              className={`nav-button ${!currentPayPeriod?.payPeriod.nextId ? 'disabled' : ''}`}
              onClick={onNextPayPeriod}
            >
              <BsChevronRight />
            </div>
          </div>
        </div>
      </div>

      <PunchCardsTable onViewDriverDetails={viewDriverDetails}/>
    </div>
  );
}
